import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=456e3549&scoped=true&"
import script from "./chips.vue?vue&type=script&lang=js&"
export * from "./chips.vue?vue&type=script&lang=js&"
import style0 from "./chips.vue?vue&type=style&index=0&id=456e3549&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e3549",
  null
  
)

export default component.exports